import SidePage from '@/shared/SidePage'
import SeparateLine from '@/shared/Forms/SeparateLine'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'

interface IProps {
  open: boolean
  onClose: () => void
}

const CreatePassportSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [draft, _, handleChange] = useStateWithChange({ name: '' })

  const handleSave = () => {
    wait(mdmApi.createPassportSchema({ ...draft, fields: [] }), (resp) => {
      if (resp.status === 'success') {
        mdmEvents.passportSchemaCreated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <SidePage onClose={props.onClose} open={props.open}>
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h2 className="text-heading-4">Создание схемы паспорта</h2>
        <SeparateLine />
        <FormField label="Наименование" required={true}>
          <TextInput value={draft.name} name="name" onChange={handleChange} placeHolder="Введите наименование" />
        </FormField>
        <p className="text-nm text-warning">
          * Конфигурирование схемы паспорта станет доступно после инициализации в настоящей форме
        </p>

        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
          <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={loading} />
        </div>
      </div>
    </SidePage>
  )
}

export default CreatePassportSidePage
